<dashboardnav>
    <cradua-audittray
    [audittrays]="audittrays$ | async"
    [actionedstaff]="actionedstaff$ | async"

    (audittray)="onSubmitAudittray($event)"
    (deleteAudittrayEvent)="onDeleteAudittray($event)"
   
    *ngIf="
    !(isLoadingAudittray$ | async ) &&
    !(isLoadingActionedstaff$ | async ) 
    "
    >
  </cradua-audittray>

    <mrsoftapps-epims-reference-spinner
  
    *ngIf="
    (isLoadingAudittray$ | async ) ||
    (isLoadingActionedstaff$ | async )
    "
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
